import { render, staticRenderFns } from "./UserFormTwoFactor.vue?vue&type=template&id=f1133d72&scoped=true&"
import script from "./UserFormTwoFactor.vue?vue&type=script&lang=js&"
export * from "./UserFormTwoFactor.vue?vue&type=script&lang=js&"
import style0 from "./UserFormTwoFactor.vue?vue&type=style&index=0&id=f1133d72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1133d72",
  null
  
)

export default component.exports